import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-graphite text-bone pt-20 md:pt-32 pb-8 px-6 mt-20 md:mt-32">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-16 md:mb-24">
        <div className="md:col-span-6 lg:col-span-5">
          <h2 className="text-4xl md:text-5xl lg:text-7xl tracking-tighter mb-6 md:mb-8 leading-[0.9]">ARCLOOM<br/>ATELIER</h2>
          <p className="text-sm md:text-base text-bone/60 max-w-xs leading-relaxed">
            Redefining the modern uniform through stark minimalism, architectural silhouettes, and uncompromising quality.
          </p>
        </div>
        
        <div className="md:col-span-3 lg:col-span-2 lg:col-start-8">
          <h4 className="text-xs uppercase tracking-widest mb-6 md:mb-8 text-crimson font-bold">Navigation</h4>
          <ul className="space-y-4 text-sm font-medium tracking-wide">
            <li><Link to="/collection" className="hover:text-white transition-colors">Capsule 01</Link></li>
            <li><Link to="/lookbook" className="hover:text-white transition-colors">Lookbook</Link></li>
            <li><Link to="/info" className="hover:text-white transition-colors">Information</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3 lg:col-span-2">
          <h4 className="text-xs uppercase tracking-widest mb-6 md:mb-8 text-crimson font-bold">Connect</h4>
          <ul className="space-y-4 text-sm font-medium tracking-wide">
            <li><a href="#" className="hover:text-white transition-colors">Instagram</a></li>
            <li><a href="#" className="hover:text-white transition-colors">Journal</a></li>
            <li><a href="#" className="hover:text-white transition-colors">Newsletter</a></li>
          </ul>
        </div>
      </div>
      
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start md:items-center text-[10px] md:text-xs text-bone/40 border-t border-bone/10 pt-8 gap-4">
        <p className="uppercase tracking-widest">&copy; {new Date().getFullYear()} ARCLOOM ATELIER. ALL RIGHTS RESERVED.</p>
        <p className="tracking-widest text-bone/50">Made by <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer">DigLab.ai</a> and <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer">LingLinkAI.cn</a></p>
      </div>
    </footer>
  );
}